<template>
  <div>
    <slot/>
  </div>
</template>

<script>
/* global google */
export default {
  props: {
    google: {
      type: Object,
    },
    map: {
      type: Object,
    },
  },
  provide() {
    return {
      google: this.google,
      map: this.map,
    };
  },
};
</script>
